<template>
  <div>
    <b-loading :active.sync="loading" />
    <div class="w-full flex justify-between items-start">
      <Lynx-Title text="Alvarás e Taxas" />
          <Lynx-Button
            text="Relatorio Taxa"
            class=""
            style="margin-top: 32px"
            @click.native="gerarRelatorio('taxa')"
            size="small"
            icon-size="3"
          />
          <Lynx-Button
            text="Relatorio Alvara"
            class=""
            style="margin-top: 32px"
            @click.native="gerarRelatorio('alvara')"
            size="small"
            icon-size="3"
          />
    </div>

    <div class="flex flex-col">
      <div class="w-full flex">
        <label class="flex flex-col w-1/4 pb-6 pr-3">
          <Lynx-Label label="Data Inicial" />
          <b-datepicker
            v-model="form.data_inicio"
            placeholder="Selecione uma data"
            :date-formatter="
              (date) => moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')
            "
            :date-parser="(date) => new Date(date)"
            :month-names="monthNames"
            :day-names="dayNames"
            :years-range="[-20, 10]"
          />
        </label>
        <label class="flex flex-col w-1/4 pb-6 pr-3">
          <Lynx-Label label="Data Final" />
          <b-datepicker
            v-model="form.data_fim"
            placeholder="Selecione uma data"
            :date-formatter="
              (date) => moment(date, 'YYYY/MM/DD').format('DD/MM/YYYY')
            "
            :date-parser="(date) => new Date(date)"
            :month-names="monthNames"
            :day-names="dayNames"
            :years-range="[-20, 10]"
          />
        </label>
        <label class="flex flex-col w-1/4 pb-6 pr-3">
          <Lynx-Label label="Status  Alvara" />

          <treeselect
            :multiple="false"
            :options="lista_status"
            placeholder="Selecione o status..."
            v-model="status_alvara"
          />
        </label>

        <label class="flex flex-col w-1/4 pb-6 pr-3">
          <Lynx-Label label="Status  Taxa" />

          <treeselect
            :multiple="false"
            :options="lista_status"
            placeholder="Selecione o status..."
            v-model="status_taxa"
          />
        </label>
        <label class="flex flex-col w-1/4 pb-6 pr-3">
          <Lynx-Label label="Tipo Alvara" />

          <treeselect
            :multiple="false"
            :options="lista_tipo_alvara"
            placeholder="Selecione o status..."
            v-model="tipo_alvara"
          />
        </label>

     
      </div>
    </div>
    <b-table
      v-if="lista_empresasAlvaras.length"
      :data="lista_empresasAlvaras"
      hoverables
      paginated
      per-page="10"
      class="w-full pb-8"
      style="font-size: smaller"
    >
      <template slot-scope="props">
        <b-table-column
          label="ID"
          field="id"
          v-text="props.row.id"
          sortable
          searchable
          style="width: 50px"
        />
        <b-table-column
          label="Empresa"
          field="razao_social"
          v-text="props.row.razao_social"
          sortable
          searchable
        />
        <!-- <b-table-column label="Status Alvara"  >
          <span v-if="hasNoAlvaras(props.row)">
      <div class="bg-primary-600 text-neutral-100 pl-2 " style="border-radius: 10px;">
        Nenhuma taxa encontrada.
      </div>
      </span>
          <span v-else
          v-for="(alvara, index) in [
                ...(props.row.alvara ? [props.row.alvara] : []),
                ...(props.row.bombeiro ? [props.row.bombeiro] : []),
                ...(props.row.alvara_sanitario ? [props.row.alvara_sanitario] : [])
              ]"
            :key="index"
          >
            <div :class="getStatusClass(alvara)">
              {{ getStatus(alvara) }} 
            </div>
          </span>
      </b-table-column> -->
        <b-table-column label="Vencimento Alvara">
          <span v-if="hasNoAlvaras(props.row)">
            <div
              class="bg-primary-600 text-neutral-100 pl-2"
              style="border-radius: 10px"
            >
              Nenhuma taxa encontrada.
            </div>
          </span>
          <span
            v-else
            v-for="(alvara, index) in [
              ...(props.row.alvara ? [props.row.alvara] : []),
              ...(props.row.bombeiro ? [props.row.bombeiro] : []),
              ...(props.row.ambiental ? [props.row.ambiental] : []),
              ...(props.row.alvara_sanitario
                ? [props.row.alvara_sanitario]
                : []),
            ]"
            :key="index"
          >
            <div :class="getStatusClass(alvara)">
              {{ getStatus(alvara) }}: {{ alvara.tipo_document }}
              <span v-if="!alvara.definitivo ? true :alvara.definitivo == null">
                {{ alvara.data_vencimento | formatEnToBr }}</span
              >
            </div>
          </span>
        </b-table-column>

       
        <!-- <b-table-column label="Status Taxas"  >
          <span v-if="hasNoTaxas(props.row)">
      <div class="bg-primary-600 text-neutral-100 pl-2 " style="border-radius: 10px;">
        Nenhuma taxa encontrada.
      </div>
      </span>
          <span v-else
            v-for="(taxa, index) in [
              ...(props.row.alvara ? props.row.alvara.taxas : []),
              ...(props.row.bombeiro ? props.row.bombeiro.taxas : []),
              ...(props.row.alvara_sanitario ? props.row.alvara_sanitario.taxas : [])
            ]"
            :key="index"
            class="status-text"
          >
            <div :class="getStatusClass(taxa)">
              {{ getStatus(taxa) }} 
            </div>
          </span>
      </b-table-column> -->

        <b-table-column label="Vencimento Taxas">
          <span v-if="hasNoTaxas(props.row)">
            <div
              class="bg-primary-600 text-neutral-100 pl-2"
              style="border-radius: 10px"
            >
              Nenhuma taxa encontrada.
            </div>
          </span>
          <span
            v-else
            v-for="(taxa, index) in [
              ...(props.row.alvara ? props.row.alvara.taxas : []),
              ...(props.row.bombeiro ? props.row.bombeiro.taxas : []),
              ...(props.row.alvara_sanitario
                ? props.row.alvara_sanitario.taxas
                : []),
            ]"
            :key="index"
            class="yellow-text"
          >
            <div :class="getStatusClass(taxa)">
              {{ getStatus(taxa) }}: {{ taxa.type_document }} -
              {{ taxa.data_vencimento | formatEnToBr }}
            </div>
          </span>
        </b-table-column>
   

            <b-table-column
          label="Estado"
          field="endereco.uf"
         
          sortable
          searchable
        > <span v-if="props.row.endereco">{{props.row.endereco.uf}}</span></b-table-column>
           <b-table-column
          label="Cidade"
          field="endereco.cidade"
        
          sortable
          searchable
        > <span v-if="props.row.endereco">{{props.row.endereco.cidade}}</span></b-table-column>
     <b-table-column label="Ações">
          <div class="flex text-sm items-center">
            <a
              href="#"
              class="mr-4 bg-primary-600 rounded-full p-2"
              @click.prevent="openEditModal(props.row)"
            >
              <Icon-Edit class="text-neutral-100" size="4" />
            </a>
            <a
              href="#"
              class="bg-error-base rounded-full p-2"
              @click.prevent="deleteTaxa(props.row.id)"
            >
              <Icon-Trash class="text-neutral-100" size="4" />
            </a>
          </div>
        </b-table-column>

      </template>
    </b-table>
    <Not-Found-Data v-else-if="!loading" text="Nenhum alvará registrado" />
    <b-modal :active.sync="editModal" v-if="editModal" width="500px">
      <v-card class="p-3">
        <Alvaras class="mt-4"  />
      </v-card>
    </b-modal>
    <b-modal :active.sync="createModal" v-if="createModal" width="500px">
      <Create-Taxa @create-taxa="onCreateTaxa" />
    </b-modal>
  </div>
</template>

<script>
import {
  indexEmpresasAlvarasRequest,
  // destroyEmpresasAlvarasRequest,
} from "@/services/requests/taxas";
// import EditTaxa from "@/views/empresas/taxasAlvaras/Edit";
// import CreateTaxa from "@/views/empresas/taxasAlvaras/Create";
import NotFoundData from "@/components/layouts/NotFoundData";
import moment from "moment";
import { monthNames, dayNames } from "@/utils/utils";
import { formatEnToBr,formatBrToEn } from "@/utils/momentHelpers";

import Treeselect from "@riophae/vue-treeselect";
import Alvaras from "@/views/empresas/show/Alvaras";
import { mapGetters } from "vuex";

export default {
  name: "EmpresasAlvarasIndex",
  components: { NotFoundData, Treeselect, Alvaras },
  data() {
    return {
      monthNames,
      dayNames,
      moment,
      loading: false,
      createModal: false,
      editModal: false,
      empresasAlvaras: [],

      currentEmpAlvs: null,
      carteira: null,
      carteiras: [],
      status_alvara: null,
      status_taxa: null,
      tipo_alvara: null,
      form: {
        data_inicio: new Date(),
        data_fim: new Date(),
        // carteira: {},
      },
      lista_status: [
        { id: "todos", label: "todos" },

        { id: "definitivo", label: "Definitivo" },
        { id: "prox_venc", label: "Prox venc" },
        { id: "normal", label: "Normal" },
        { id: "vencido", label: "Vencido" },
      ],
      lista_tipo_alvara: [
        { id: "todos", label: "todos" },

        { id: "alvara", label: "Alvara" },
        { id: "bombeiro", label: "Bombeiro" },
        { id: "sanitario", label: "Sanitario" },
        { id: "ambiental", label: "Ambiental" },

        
      ],
    };
  },

  filters: {
    formatEnToBr,

    statusType: (val) => {
      if (val.status === "normal") {
        return "is-success";
      }

      if (val.status === "vencido") {
        return "is-danger";
      }
      if (val.status === "prox venc") {
        return "is-warning";
      }
      if (val.status === "definitivo") {
        return "is-primary";
      }
      return "default";
    },
  },
  computed: {
    ...mapGetters(["getToken"]),

    lista_empresasAlvaras() {
      let data = this.empresasAlvaras;
      let r, r2, r3;
      let x, x2;
      r = data.filter((item2) => {
        if (!this.status_alvara || this.status_alvara === "todos") return true;
        switch (this.tipo_alvara) {
          case "bombeiro":
            if (item2.bombeiro) {
              x = this.filtragens(item2.bombeiro);
            } else {
              x = false;
            }
            break;

          case "alvara":
            if (item2.alvara) {
              x = this.filtragens(item2.alvara);
            } else {
              x = false;
            }

            break;

          case "sanitario":
            if (item2.alvara_sanitario) {
              x = this.filtragens(item2.alvara_sanitario);
            } else {
              x = false;
            }
            break;

            case "ambiental":
            if (item2.ambiental) {
              x = this.filtragens(item2.ambiental);
            } else {
              x = false;
            }
            break;

          default:
            if (item2.alvara) {
              x = this.filtragens(item2.alvara);
            }
            if (item2.alvara_sanitario) {
              x = this.filtragens(item2.alvara_sanitario);
            }

            if (item2.bombeiro) {
              x = this.filtragens(item2.bombeiro);
            }

            if (item2.ambiental) {
              x = this.filtragens(item2.ambiental);
            }
            // x = false

            break;
        }

        return x;
      });

      r2 = r.filter((item3) => {
        if (!this.status_taxa || this.status_taxa === "todos") return true;
        switch (this.tipo_alvara) {
          case "bombeiro":
            if (item3.bombeiro && item3.bombeiro.taxas.length > 0) {
              x2 = this.filtragens2(item3.bombeiro.taxas);
            } else {
              x2 = false;
            }
            break;
          case "alvara":
            if (item3.alvara && item3.alvara.taxas.length > 0) {
              x2 = this.filtragens2(item3.alvara.taxas);
              console.log(x2);
            } else {
              x2 = false;
            }
            break;
          case "sanitario":
            if (
              item3.alvara_sanitario &&
              item3.alvara_sanitario.taxas.length > 0
            ) {
              x2 = this.filtragens2(item3.alvara_sanitario.taxas);
            } else {
              x2 = false;
            }
            break;

            case "ambiental":
            if (
              item3.ambiental &&
              item3.ambiental.taxas.length > 0
            ) {
              x2 = this.filtragens2(item3.ambiental.taxas);
            } else {
              x2 = false;
            }
            break;

          default:
            // if (item3.alvara && item3.alvara.taxas) {
            //   x2 = this.filtragens2(item3.alvara.taxas);
            //   }
            //   if (item3.alvara_sanitario && item3.alvara_sanitario.taxas) {
            //     x2 = this.filtragens2(item3.alvara_sanitario.taxas);
            //   }

            //   if (item3.bombeiro && item3.bombeiro.taxas) {
            //     x2 = this.filtragens2(item3.bombeiro.taxas);
            //   }
            x = false;

            break;
        }

        return x2;
      });
      return r2;
    },
  },

  methods: {
    filtragens(data) {
      let b, c;
      const today = new Date();
      const vencimento = new Date(data.data_vencimento);
      const diffDays = Math.ceil((vencimento - today) / (1000 * 60 * 60 * 24));

      switch (this.status_alvara) {
        case "prox_venc":
          b = diffDays > 0 && diffDays <= 45 ? true : false;
          break;
        case "vencido":
          b = diffDays <= 0 ? true : false;
          break;
        case "normal":
          b = diffDays > 45 ? true : false;
          break;
        case "definitivo":
          b =
            data.tipo_document == "alvara"
              ? !data.definitivo
                ? false
                : true
              : false;

          break;

        default:
          b = false;
          break;
      }

      return b;
    },
    filtragens2(value) {
      let b;

      let result = value.filter((data) => {
        const today = new Date();
        const vencimento = new Date(data.data_vencimento);
        const diffDays = Math.ceil(
          (vencimento - today) / (1000 * 60 * 60 * 24)
        );
        switch (this.status_taxa) {
          case "prox_venc":
            b = diffDays > 0 && diffDays <= 45 ? true : false;
            break;
          case "vencido":
            b = diffDays <= 0 ? true : false;
            break;
          case "normal":
            b = diffDays > 45 ? true : false;
            break;

          default:
            b = false;
            break;
        }
        return b;
      });

      return result.length > 0 ? true : false;
    },
    getStatus(value) {
      const today = new Date();
      const vencimento = new Date(value.data_vencimento);
      const diffDays = Math.ceil((vencimento - today) / (1000 * 60 * 60 * 24));

      if (
        !value.tipo_document
          ? false
          : value.tipo_document == "alvara"
          ? !value.definitivo
            ? false
            : true
          : false
      ) {
        return "Definitivo";
      }

      if (diffDays <= 0) {
        return "Vencido";
      } else if (diffDays <= 45) {
        return "Próximo do Vencimento";
      } else {
        return "Normal";
      }
    },
    getStatusClass(taxa) {
      const status = this.getStatus(taxa);


     return  status === "Vencido" ? "bg-error-base text-neutral-100 pl-1 mt-1 rounded" :
  status === "Próximo do Vencimento" ? "bg-warning-base text-neutral-100 pl-1 mt-1 rounded" :
  status === "Normal" ? "bg-success-base text-neutral-100 pl-1 mt-1 rounded" :
  "bg-primary-600 text-neutral-100 pl-1 mt-1 rounded";
    },

    hasNoAlvaras(row) {
      return !row.alvara && !row.ambiental && !row.bombeiro && !row.alvara_sanitario;
    },
    hasNoTaxas(row) {
      return (
        !(row.alvara && row.alvara.taxas.length > 0) &&
        !(row.bombeiro && row.bombeiro.taxas.length > 0) &&
        !(row.ambiental && row.ambiental.taxas.length > 0) &&

        !(row.alvara_sanitario && row.alvara_sanitario.taxas.length > 0)
      );
    },
    fetchEmpresasAlvaras() {
      this.loading = true;
      indexEmpresasAlvarasRequest()
        .then((res) => (this.empresasAlvaras = res.data.data))
        .finally(() => (this.loading = false));
    },
    openCreateModal() {
      this.createModal = true;
    },
    openEditModal(currentEmpAlvs) {
      this.$store.dispatch("setEmpresa", currentEmpAlvs);
      this.currentEmpAlvs = currentEmpAlvs;
      this.editModal = true;
    },
    onEditTaxa() {
      this.fetchEmpresasAlvaras();
      this.editModal = false;
    },
    onCreateTaxa() {
      this.fetchEmpresasAlvaras();
      this.createModal = false;
    },
    deleteTaxa(id) {
      this.$buefy.dialog.confirm({
        message: "Deseja realmente excluir o alvará desta empresa?",
        confirmText: "Excluir",
        cancelText: "Cancelar",
        type: "is-danger",
        onConfirm: () => this.onDeleteTaxa(id),
      });
    },
    onDeleteTaxa(id) {
      destroyEmpresasAlvarasRequest(id)
        .then(() => {
          this.$snack.success("Alvará excluido com sucesso");
          this.fetchEmpresasAlvaras();
        })
        .catch(() => this.$snack.error("Não foi possivel excluir o alvará"));
    },
    gerarRelatorio(t) {
      this.form.tipo_alvara = this.tipo_alvara;

let form = {
  data_inicio :  formatBrToEn(this.form.data_inicio),
  data_fim :formatBrToEn(this.form.data_fim),
  tipo_alvara :this.form.tipo_alvara

}
const parametrosString = Object.entries(form)
    .map(([chave, valor]) => `${encodeURIComponent(chave)}=${encodeURIComponent(valor)}`)
    .join('&');
      // console.log(this.form)
   
      if(t == 'taxa'){

    
      const baseUrl2 =  `${process.env.VUE_APP_API_URL}/empresas/alvarastaxas/relatorio`;
  
    const urlCompleta = `${baseUrl2}?${parametrosString}`;
    window.open(urlCompleta+`&token=${this.getToken}`,   "_blank")

      // this.$store.dispatch("empresas/gerarRelatorioTaxa", this.form);
    }else{

      const baseUrl =  `${process.env.VUE_APP_API_URL}/empresas/tipoalvaras/relatorio`;
   
    const urlCompleta = `${baseUrl}?${parametrosString}`;
    window.open(urlCompleta+`&token=${this.getToken}`,   "_blank")
      // this.$store.dispatch("empresas/gerarRelatorioAlvara", this.form);

    }
    },
  },
  beforeMount() {
    this.fetchEmpresasAlvaras();
  },
};
</script>
